

export class AiSpeachGenerationFile{
 uid:string;
 jobID:string;
 name:string;
 progress:number;
 data:PDFPage[];
 constructor(uid:string,jobID:string,name:string,data:PDFPage[]) {
   this.uid=uid;
   this.jobID=jobID;
   this.name=name;
   this.data=data;
   this.progress=0;
 }
}

export interface PDFPage{
  pageNumber:number;
  content:string;
  imageB64:string;
}
